import { useCacheSlice } from '../hooks'

export type Matter = {
  matter: string
  matter_id: string
  client: string
  description: string
  task_group: string
  activity_group: string
  is_recent?: number
}

export function useMattersCache() {
  const { data, isLoading } = useCacheSlice('matters')
  const matters = data as Matter[]
  return { matters, isLoading }
}
